
























import { defineComponent } from '@vue/composition-api';
import QuotaDetailsContainer from '../quota-detail-container/index.vue';
import ALink from '@/components/common/a-link/a-link.vue';

const name = 'ttam-ios14-info-quota-detail-limit';
export default defineComponent({
  name,
  components: {
    QuotaDetailsContainer,
    ALink,
  },
  setup() {
    return {
      name,
    };
  },
});
